import { useCallback } from 'react'

import { FORMIK_EMPTY_VALUE } from '../../../../../../../../constants/validation'
import { NEWSBOARD_POST_FORM_RECIPIENTS_INITIAL_VALUES } from '../../../RecipientsField.constants'
import {
  parseChangedValues,
  parseSubmitValues,
} from '../../CustomizeRecipientAudienceField.utils'

export function useChangeFields({
  getTagValue,
  initialValues,
  setInitialValues,
  onChangeRecipientField,
}) {
  const handleChangeTagList = useCallback(
    (valueList, excludedValue) => {
      if (valueList.length === 0) {
        setInitialValues(NEWSBOARD_POST_FORM_RECIPIENTS_INITIAL_VALUES)
        onChangeRecipientField(FORMIK_EMPTY_VALUE)
      } else {
        const nextValues = parseChangedValues({
          excludedValue,
          getTagValue: getTagValue,
          valueList,
          values: initialValues,
        })

        setInitialValues(nextValues)
        onChangeRecipientField(parseSubmitValues(nextValues))
      }
    },
    [getTagValue, initialValues, onChangeRecipientField, setInitialValues]
  )

  return { handleChangeTagList }
}
